<div id="storeLogoComp" class="model_sku">
  <!-- Main section -->
  <section>
    <!-- Enter Mode SKU: Localized display names -->
    <div id="UploadstoreLogoIcon" class="main_section_headers">
      <img class="header_icon" alt="Upload logos" />
      <span i18n="@@upload-storelogo.header.upload-logo">Upload logos</span>
    </div>
    <ng-container *ngIf="!isStoreImg">
      <iposcen-spinner-overlay></iposcen-spinner-overlay>
    </ng-container>
    <ng-container *ngIf="isStoreImg">
    <label>
      <input #imageInput id="uploadLogo" type="file" accept="image/jpg,image/jfif,image/x-png,image/jpeg,image/gif"
        (change)="processFile(imageInput)" hidden>
    </label>
    <div id="uploadLogoSecBody" class="main_section_body upload_section">
      <!-- Data header with info like no. of content groups, action buttons and filters -->
      <div id="uploadLogoSecDataHeader" class="data_header">
        <span class="data_desc">
          <span i18n="@@upload-storelogo.header.data-title" class="data_title" *ngIf="logo.length >= 2 || logo.length == 0">{{logo.length}} Logos</span>
          <span class="data_title" *ngIf="logo.length == 1">{{logo.length}} {{logoLabel}}</span>
          <ng-container *ngIf="logo.length >= 2">
            <span i18n="@@upload-image.header.sort-by">Sort by</span>:&nbsp;
            <div ngbDropdown class="btn-group">
              <button ngbDropdownToggle type="button" class="btn btn-primary btn-sm dropdown-toggle" id="storeDropDown">
                {{uploadLogoSortValue}}
              </button>
              <div id="storeLogoData" ngbDropdownMenu aria-labelledby="storeDropDown">
                <a ngbDropdownItem *ngIf="uploadLogoSortValue!== uploadDateOption" (click)="sortBy('uploadDate')"><span
                    i18n="@@upload-image.dropdown.upload-date">Upload Date</span></a>
                <a ngbDropdownItem *ngIf="uploadLogoSortValue!== fileNameOption" (click)="sortBy('fileName')"> <span
                    i18n="@@upload-image.dropdown.file-name">File Name</span></a>
              </div>
            </div>
          </ng-container>
        </span>
        <span id="storeLogoActionBtn" class="data_action">
          <div id="uploadButton" class="d-flex flex-column align-items-end">
            <div>
              <label>
                <button type="button" class="btn btn-primary btn-sm left_icon_btn" (click)="imageInput.click()">
                  <svg width="16" height="17" viewBox="0 0 16 17" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M0.5 8.25822C0.632608 8.25822 0.759785 8.3109 0.853553 8.40467C0.947322 8.49844 1 8.62561 1 8.75822V12.2582C1 12.5234 1.10536 12.7778 1.29289 12.9653C1.48043 13.1529 1.73478 13.2582 2 13.2582H14C14.2652 13.2582 14.5196 13.1529 14.7071 12.9653C14.8946 12.7778 15 12.5234 15 12.2582V8.75822C15 8.62561 15.0527 8.49844 15.1464 8.40467C15.2402 8.3109 15.3674 8.25822 15.5 8.25822C15.6326 8.25822 15.7598 8.3109 15.8536 8.40467C15.9473 8.49844 16 8.62561 16 8.75822V12.2582C16 12.7887 15.7893 13.2974 15.4142 13.6724C15.0391 14.0475 14.5304 14.2582 14 14.2582H2C1.46957 14.2582 0.960859 14.0475 0.585786 13.6724C0.210714 13.2974 0 12.7887 0 12.2582V8.75822C0 8.62561 0.0526784 8.49844 0.146447 8.40467C0.240215 8.3109 0.367392 8.25822 0.5 8.25822ZM5 5.11222C5.09376 5.20596 5.22092 5.25862 5.3535 5.25862C5.48608 5.25862 5.61324 5.20596 5.707 5.11222L8 2.81822L10.293 5.11122C10.3391 5.15898 10.3943 5.19707 10.4553 5.22327C10.5163 5.24948 10.5819 5.26327 10.6483 5.26385C10.7147 5.26442 10.7805 5.25177 10.842 5.22663C10.9034 5.20149 10.9593 5.16437 11.0062 5.11742C11.0531 5.07047 11.0903 5.01465 11.1154 4.9532C11.1406 4.89175 11.1532 4.82591 11.1526 4.75952C11.152 4.69313 11.1383 4.62752 11.1121 4.56652C11.0858 4.50552 11.0478 4.45035 11 4.40422L8.354 1.75822C8.30755 1.71166 8.25238 1.67472 8.19163 1.64951C8.13089 1.6243 8.06577 1.61133 8 1.61133C7.93423 1.61133 7.86911 1.6243 7.80837 1.64951C7.74762 1.67472 7.69245 1.71166 7.646 1.75822L5 4.40422C4.95344 4.45067 4.91649 4.50584 4.89129 4.56659C4.86608 4.62733 4.85311 4.69246 4.85311 4.75822C4.85311 4.82399 4.86608 4.88911 4.89129 4.94986C4.91649 5.0106 4.95344 5.06578 5 5.11222Z" />
                    <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M8 2.25781C8.13261 2.25781 8.25979 2.31049 8.35355 2.40426C8.44732 2.49803 8.5 2.6252 8.5 2.75781V10.7578C8.5 10.8904 8.44732 11.0176 8.35355 11.1114C8.25979 11.2051 8.13261 11.2578 8 11.2578C7.86739 11.2578 7.74021 11.2051 7.64645 11.1114C7.55268 11.0176 7.5 10.8904 7.5 10.7578V2.75781C7.5 2.6252 7.55268 2.49803 7.64645 2.40426C7.74021 2.31049 7.86739 2.25781 8 2.25781Z" />
                  </svg><span i18n="@@upload-storelogo.button.upload-logo">Upload Logo</span>
                </button>
              </label>
              &nbsp;
              <ng-template #popContent>
                <div id="popContent" class="popover-upload-req">
                  <div id="popContentHeaderIcon" class="d-flex align-items-center">
                    <img class="header_icon" alt="image" />
                    <ul>
                      <li><span i18n="@@upload-image.hover.data">Images must be in <strong>JPG, PNG, JPEG,
                            JFIF</strong> or <strong>GIF</strong> format</span></li>
                      <li><span i18n="@@upload-image.hover.allowed">Allowed maximum size is <strong>5 MB</strong></span>
                      </li>
                    </ul>
                  </div>
                </div>
              </ng-template>
              <img class="info-icon-msg" alt="hover for help" [ngbPopover]="popContent" placement="left"
                triggers="mouseenter:mouseleave" />
            </div>
            <div id="imageTypeError" *ngIf="isImageTypeError" class="uploadfile_erorr_msg error-width"><span
                i18n="@@upload-image.error-msg.incorrect">Incorrect file type received. Image must be in
                <strong>JPG, PNG, JPEG, JFIF </strong>or <strong>GIF </strong>format.</span>
            </div>
            <div id="imageSizeError" *ngIf="isImageSizeError && isimageFormat" class="uploadfile_erorr_msg error-width-size">
              <span i18n="@@upload-image.size-error-msg.file-size">File exceeds maximum size <strong>(5
                  MB).</strong></span>
            </div>
          </div>
        </span>
      </div>

      <!--No Images -->
      
      <div id="noImageUpload" class="no_assets" *ngIf="logo.length == 0">
        <div id="textNote" class="text-note">
          <span i18n="@@upload-image.msg.no-image">Please upload assets to use them while creating content group</span>
        </div>
        <div id="uploadIcon" class="add_new_button" (click)='imageInput.click()'>
          <img class="plus-upload-icon" alt="Upload Icon" />
        </div>
      </div>
      <!-- Images -->
      <div id="storeLogoCardDeck" class="card-deck deck" *ngIf="logo.length > 0">
        <div id="storeLogoCard" class="card" *ngFor="let logo of logo">
          <img class="card-img-top img-card" [src]="logo.imageData" alt="logo" />
          <div id="storeLogoCardFooter" class="card-footer">
            <span ngbTooltip={{logo.fileName}}>{{logo.shortFileName}}</span>
            <span class="delete_icon_position" role="button" placement="top" ngbTooltip="{{deleteTooltipLabel}}" (click)="open(logo)">
              <img class="delete_Icon_img" alt="delete" />
            </span>
            <ng-template #LogoDeleteModal>
              <div id="logoDeleteModal" class="card deletePopup">
                <div id="logoDeleteModalHeader" class="modal-header">
                  <div id="logoDeleteModalCloseIcon" (click)="dismiss()" class="close_icon">
                    <img src="assets/images/popup_close_button.svg" alt="close icon" />
                  </div>
                </div>
                <div id="logoDeleteModalBody" class="modal-body popup-body">
                  <h2><span i18n="@@upload-image.popup.delete">Delete</span> {{deleteLogoLable}}?</h2>
                  <div id="permanentLogoDelete" *ngIf='!isDeleteDisable' class="card_desc">
                    <span i18n="@@upload-image.popup.permanent-delete">This asset will be permanently deleted.</span>
                  </div>
                  <div id="logoDeleteDisable" *ngIf='isDeleteDisable' class="card_desc">
                    <span i18n="@@upload-image.popup.used-no-delete">This asset is used in the Content Group and you cannot delete it.</span>
                  </div>
                </div>
                <div id="logoDeleteModalActionBtn" *ngIf='!isDeleteDisable' class="modal-footer card-footer popup-footer">
                  <button type="button" (click)="dismiss()"
                    class="btn btn-outline-primary gtmCancelDltContGrp cancel-btn">
                    <span i18n="@@upload-image.button.cancel">Cancel</span>
                  </button>
                  <button type="button" class="btn btn-primary gtmDeleteContGrp delete-btn" (click)="deleteLogo()">
                    <span i18n="@@upload-image.button.delete-media">Delete Media</span>
                  </button>
                </div>
                <div *ngIf='isDeleteDisable' class="modal-footer card-footer popup-footer">
                  <button type="button" (click)="dismiss()" class="btn btn-primary gtmCancelDltContGrp cancel-btn">
                    <span i18n="@@upload-image.button.ok">ok</span>
                  </button>
                </div>

              </div>
            </ng-template>
          </div>
          <div id="logoUploadedTimeStamp" class="card-body"><span i18n="@@upload-image.cardBody.uploaded">
              <strong>Uploaded</strong> {{logo.updatedTime | dateFormat: "changeToLocalTimeZone"}}</span>
          </div>
        </div>

        <div id="logoUploadIcon" class="card add_new_button" *ngIf="logo.length > 0" role="button" (click)='imageInput.click()'>
          <img class="plus-upload-icon" alt="Upload Icon" />
        </div>
      </div>
    </div>

    <!-- Enter Model SKU: blocks end here -->
    <div id="storeLogoActionBtn" class="button_wrapper" style="justify-content: flex-end">
      <button type="button" class="btn btn-outline-primary btn-lg" (click)="goBack()">
        <span i18n="@@upload-image.button.cancel">Cancel</span>
      </button>
      <button type="button" class="btn btn-primary btn-lg" (click)="goNext()">
        <span i18n="@@upload-storeLogo.button.proceed-to-complete">Proceed to Complete</span>
      </button>
    </div>
  </ng-container>
  </section>
</div>